{
  "app": {
    "title": "Pájaro en Mano",
    "titleShort": "BITH"
  },
  "navigation": {
    "dashboard": "Tablero",
    "allocationHistory": "Historial de Asignación",
    "withdrawals": "Retiros",
    "settings": "Configuración",
    "admin": "Administración",
    "adminUsers": "Usuarios",
    "adminInvites": "Invitaciones",
    "adminProfits": "Ganancias",
    "adminWithdrawals": "Retiros",
    "logout": "Cerrar Sesión"
  },
  "buttons": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "submit": "Enviar",
    "close": "Cerrar",
    "edit": "Editar",
    "delete": "Eliminar",
    "confirm": "Confirmar",
    "back": "Atrás",
    "next": "Siguiente",
    "refresh": "Actualizar",
    "filter": "Filtrar",
    "clear": "Limpiar",
    "download": "Descargar",
    "upload": "Subir",
    "search": "Buscar",
    "apply": "Aplicar",
    "reset": "Restablecer"
  },
  "status": {
    "active": "Activo",
    "inactive": "Inactivo",
    "pending": "Pendiente",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "completed": "Completado",
    "processing": "Procesando",
    "failed": "Fallido",
    "success": "Éxito",
    "error": "Error",
    "loading": "Cargando..."
  },
  "common": {
    "yes": "Sí",
    "no": "No",
    "ok": "Aceptar",
    "or": "o",
    "and": "y",
    "of": "de",
    "to": "a",
    "from": "desde",
    "in": "en",
    "at": "en",
    "on": "en",
    "for": "para",
    "with": "con",
    "by": "por",
    "total": "Total",
    "amount": "Cantidad",
    "date": "Fecha",
    "time": "Hora",
    "email": "Correo Electrónico",
    "name": "Nombre",
    "country": "País",
    "actions": "Acciones",
    "details": "Detalles",
    "description": "Descripción",
    "notes": "Notas"
  },
  "messages": {
    "saveSuccess": "Guardado exitosamente",
    "saveFailed": "Fallo al guardar",
    "deleteSuccess": "Eliminado exitosamente",
    "deleteFailed": "Fallo al eliminar",
    "updateSuccess": "Actualizado exitosamente",
    "updateFailed": "Fallo al actualizar",
    "loadError": "Error al cargar datos",
    "networkError": "Ocurrió un error de red",
    "sessionExpired": "Su sesión ha expirado. Por favor, inicie sesión nuevamente.",
    "unauthorized": "No está autorizado para realizar esta acción",
    "notFound": "El recurso solicitado no fue encontrado",
    "validationError": "Por favor revise su entrada e intente nuevamente"
  },
  "language": {
    "label": "Idioma",
    "english": "Inglés",
    "spanish": "Español",
    "changeSuccess": "Idioma cambiado exitosamente"
  }
}
